import React, { useContext } from 'react';
import classNames from 'classnames';
import PhoneNumberHidden from '../../../../../components/PhoneNumberHidden';
import { Context } from '../../../../../context/AppContext';
import './styles.css';

const Call = ({ number, className, ...props }) => {
  const {
    media: { desktop, tablet, mobile },
    userAgent: { isTouch },
  } = useContext(Context);
  return (
    number &&
    !!number.length && (
      <PhoneNumberHidden
        tag="a"
        size="smaller"
        theme={desktop ? 'outlineLightGrey' : 'outlinePurple'}
        icon={<i className="icon-generalcalllarge" />}
        number={number[0].info}
        className={classNames('Listview__Card__call', {
          [className]: className,
        })}
        rel="noopener noreferrer nofollow"
        {...props}
      >
        {isTouch || mobile || tablet ? 'Call' : null}
      </PhoneNumberHidden>
    )
  );
};
export default Call;
